/* eslint-disable */
import {
  ArrowHelper,
  BoxGeometry,
  CylinderGeometry,
  ExtrudeGeometry,
  Group,
  Matrix4,
  Mesh,
  Shape,
  ShapeGeometry,
  Sprite,
  SpriteMaterial,
  TextTexture,
  Vector2,
  Vector3,
} from 'three';

import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';
/*
import {
  ADDITION,
  SUBTRACTION,
  INTERSECTION,
  Brush,
  Evaluator,
} from 'three-bvh-csg';*/

import { CSG } from 'three-csg-ts';

const Offsets = GenerateOffsets(200);

/* Texture offset Helper functions */

function GenerateOffsets(number) {
  const arr = [{ x: 0, y: 0 }];
  for (let i = 0; i < number; i++) {
    arr.push({ x: Math.random() / 2, y: Math.random() / 2 });
  }

  return arr;
}

/* Generic object manipulation Helper functions */

function GeometryToMesh(geo) {
  return new Mesh(geo);
}

function MeshToGeometry(mesh) {
  return mesh.geometry;
}

export function BooleanUnion(geo, ...geos) {
  let mesh = GeometryToMesh(geo);
  geos.forEach((g) => (mesh = CSG.union(mesh, GeometryToMesh(g))));
  return MeshToGeometry(mesh);
}

export function BooleanDifference(geo1, geo2) {
  const csg1 = GeometryToMesh(geo1);
  const csg2 = GeometryToMesh(geo2);
  return MeshToGeometry(CSG.subtract(csg1, csg2));
}

export function BooleanIntersection(geo1, geo2) {
  const csg1 = GeometryToMesh(geo1);
  const csg2 = GeometryToMesh(geo2);
  return MeshToGeometry(CSG.intersect(csg1, csg2));
}

/*
export function BooleanUnion(geo, ...geos) {
  const csgEvaluator = new Evaluator();
  let finalBrush = new Brush(geo);
  geos.forEach((g) => {
    const brush = new Brush(g);
    finalBrush = csgEvaluator.evaluate(finalBrush, brush, ADDITION);
  });

  return finalBrush.geometry;
}
*/
/*
export function BooleanDifference(geo1, geo2) {
  const csgEvaluator = new Evaluator();
  const brush1 = new Brush(geo1);
  const brush2 = new Brush(geo2);

  const result = csgEvaluator.evaluate(brush1, brush2, SUBTRACTION);

  return result.geometry;
}*/
/*
function BooleanIntersectionBHV(geo1, geo2) {
  const csgEvaluator = new Evaluator();
  const brush1 = new Brush(geo1);
  const brush2 = new Brush(geo2);

  const result = csgEvaluator.evaluate(brush1, brush2, INTERSECTION);

  return result.geometry;
}*/

export function RotateObject(obj, point, angle, axis = 'X') {
  // let tempPosition = new Vector3();
  // tempPosition.copy(obj.position);
  // obj.position.set(point);
  if (axis == 'X') {
    obj.rotateX((angle * Math.PI) / 180);
  }
  if (axis == 'Y') {
    obj.rotateY((angle * Math.PI) / 180);
  }
  if (axis == 'Z') {
    obj.rotateZ((angle * Math.PI) / 180);
  }

  // obj.position.set(tempPosition);
}

export function flipBufferGeometryNormals(geometry) {
  const tempXYZ = [0, 0, 0];
  if (geometry.index) geometry = geometry;
  // flip normals
  for (let i = 0; i < geometry?.attributes?.normal?.array.length / 9; i++) {
    // cache a coordinates
    tempXYZ[0] = geometry.attributes.normal.array[i * 9];
    tempXYZ[1] = geometry.attributes.normal.array[i * 9 + 1];
    tempXYZ[2] = geometry.attributes.normal.array[i * 9 + 2];

    // overwrite a with c
    geometry.attributes.normal.array[i * 9] =
      geometry.attributes.normal.array[i * 9 + 6];
    geometry.attributes.normal.array[i * 9 + 1] =
      geometry.attributes.normal.array[i * 9 + 7];
    geometry.attributes.normal.array[i * 9 + 2] =
      geometry.attributes.normal.array[i * 9 + 8];

    // overwrite c with stored a values
    geometry.attributes.normal.array[i * 9 + 6] = tempXYZ[0];
    geometry.attributes.normal.array[i * 9 + 7] = tempXYZ[1];
    geometry.attributes.normal.array[i * 9 + 8] = tempXYZ[2];
  }

  // change face winding order
  for (let i = 0; i < geometry?.attributes?.position?.array.length / 9; i++) {
    // cache a coordinates
    tempXYZ[0] = geometry.attributes.position.array[i * 9];
    tempXYZ[1] = geometry.attributes.position.array[i * 9 + 1];
    tempXYZ[2] = geometry.attributes.position.array[i * 9 + 2];

    // overwrite a with c
    geometry.attributes.position.array[i * 9] =
      geometry.attributes.position.array[i * 9 + 6];
    geometry.attributes.position.array[i * 9 + 1] =
      geometry.attributes.position.array[i * 9 + 7];
    geometry.attributes.position.array[i * 9 + 2] =
      geometry.attributes.position.array[i * 9 + 8];

    // overwrite c with stored a values
    geometry.attributes.position.array[i * 9 + 6] = tempXYZ[0];
    geometry.attributes.position.array[i * 9 + 7] = tempXYZ[1];
    geometry.attributes.position.array[i * 9 + 8] = tempXYZ[2];
  }

  // flip UV coordinates
  for (let i = 0; i < geometry?.attributes?.uv?.array.length / 6; i++) {
    // cache a coordinates
    tempXYZ[0] = geometry.attributes.uv.array[i * 6];
    tempXYZ[1] = geometry.attributes.uv.array[i * 6 + 1];

    // overwrite a with c
    geometry.attributes.uv.array[i * 6] =
      geometry.attributes.uv.array[i * 6 + 4];
    geometry.attributes.uv.array[i * 6 + 1] =
      geometry.attributes.uv.array[i * 6 + 5];

    // overwrite c with stored a values
    geometry.attributes.uv.array[i * 6 + 4] = tempXYZ[0];
    geometry.attributes.uv.array[i * 6 + 5] = tempXYZ[1];
  }

  if (geometry?.attributes?.normal) {
    geometry.attributes.normal.needsUpdate = true;
  }
  if (geometry?.attributes?.position) {
    geometry.attributes.position.needsUpdate = true;
  }
  if (geometry?.attributes?.uv) {
    geometry.attributes.uv.needsUpdate = true;
  }
}

export function MirrorObjectX(obj, copy = true) {
  let obj2 = obj;
  if (copy) {
    obj2 = obj.clone();
  }

  obj2.applyMatrix4(new Matrix4().makeScale(-1, 1, 1));
  flipBufferGeometryNormals(obj2);
  return obj2;
}

export function MirrorObjectY(obj, copy = true) {
  let obj2 = obj;
  if (copy) {
    obj2 = obj.clone();
  }

  obj2.applyMatrix4(new Matrix4().makeScale(1, -1, 1));
  flipBufferGeometryNormals(obj2);
  return obj2;
}

export function MirrorObjectZ(obj, copy = true) {
  let obj2 = obj;
  if (copy) {
    obj2 = obj.clone();
  }

  obj2.applyMatrix4(new Matrix4().makeScale(1, 1, -1));
  flipBufferGeometryNormals(obj2);
  return obj2;
}

export function updateUVs(geometry, angle, index, size = 1024, vScale = 1) {
  if (geometry) {
    if (geometry.index) {
      geometry = geometry;
    }
    if (geometry?.attributes?.normal) {
      geometry.attributes.normal.needsUpdate = true;
    }
    if (geometry?.attributes?.position) {
      geometry.attributes.position.needsUpdate = true;
    }
    if (geometry?.attributes?.uv) {
      geometry.attributes.uv.needsUpdate = true;
    }
    if (geometry?.attributes?.color) {
      geometry.deleteAttribute('color');
    }
    if (!geometry.boundingBox) geometry.computeBoundingBox();
    const { min, max } = geometry.boundingBox;
    const range = new Vector3(max.x - min.x, max.y - min.y, max.z - min.z);
    // const min = {x:0, y:0, z:0}
    const offsetX = Offsets[index].x;
    const offsetY = Offsets[index].y;
    for (let i = 0; i < geometry.attributes.position.count; i = i + 3) {
      const faceUVs = [new Vector2(), new Vector2(), new Vector2()];
      const va = new Vector3(
        geometry.attributes.position.array[3 * i],
        geometry.attributes.position.array[3 * i + 1],
        geometry.attributes.position.array[3 * i + 2]
      );
      const vb = new Vector3(
        geometry.attributes.position.array[3 * i + 3],
        geometry.attributes.position.array[3 * i + 4],
        geometry.attributes.position.array[3 * i + 5]
      );
      const vc = new Vector3(
        geometry.attributes.position.array[3 * i + 6],
        geometry.attributes.position.array[3 * i + 7],
        geometry.attributes.position.array[3 * i + 8]
      );

      const vab = new Vector3().copy(vb).sub(va);
      const vac = new Vector3().copy(vc).sub(va);
      const vcross = new Vector3().copy(vab).cross(vac);
      vcross.set(Math.abs(vcross.x), Math.abs(vcross.y), Math.abs(vcross.z));

      const majorAxis =
        vcross.x > vcross.y
          ? vcross.x > vcross.z
            ? 'x'
            : vcross.y > vcross.z
            ? 'y'
            : vcross.y > vcross.z
          : vcross.y > vcross.z
          ? 'y'
          : 'z';

      const uAxis = majorAxis == 'x' ? 'y' : majorAxis == 'y' ? 'x' : 'x';
      const vAxis = majorAxis == 'x' ? 'z' : majorAxis == 'y' ? 'z' : 'y';

      // let min = va;

      faceUVs[0].set(
        (va[uAxis] - min[uAxis]) / size + offsetX,
        (va[vAxis] - min[vAxis]) / size + offsetY
      );
      faceUVs[1].set(
        (vb[uAxis] - min[uAxis]) / size + offsetX,
        (vb[vAxis] - min[vAxis]) / size + offsetY
      );
      faceUVs[2].set(
        (vc[uAxis] - min[uAxis]) / size + offsetX,
        (vc[vAxis] - min[vAxis]) / size + offsetY
      );
      /*
      faceUVs[0].set(
        (va[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (va[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );
      faceUVs[1].set(
        (vb[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (vb[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );
      faceUVs[2].set(
        (vc[uAxis] - min[uAxis]) / range[uAxis] + offsetX,
        (vc[vAxis] - min[vAxis]) / range[vAxis] + offsetY
      );*/

      if (angle) {
        faceUVs[0].rotateAround(new Vector2(0, 0), (-angle * Math.PI) / 180);
        faceUVs[1].rotateAround(new Vector2(0, 0), (-angle * Math.PI) / 180);
        faceUVs[2].rotateAround(new Vector2(0, 0), (-angle * Math.PI) / 180);
      }

      faceUVs[0].y = faceUVs[0].y * vScale;
      faceUVs[1].y = faceUVs[1].y * vScale;
      faceUVs[2].y = faceUVs[2].y * vScale;

      // faceUVs[0].y = faceUVs[0].y;
      // faceUVs[1].y = faceUVs[1].y;
      // faceUVs[2].y = faceUVs[2].y;

      geometry.attributes.uv.array[2 * i] = faceUVs[0].x;
      geometry.attributes.uv.array[2 * i + 1] = faceUVs[0].y;
      geometry.attributes.uv.array[2 * i + 2] = faceUVs[1].x;
      geometry.attributes.uv.array[2 * i + 3] = faceUVs[1].y;
      geometry.attributes.uv.array[2 * i + 4] = faceUVs[2].x;
      geometry.attributes.uv.array[2 * i + 5] = faceUVs[2].y;
    }
    geometry.elementsNeedUpdate = geometry.verticesNeedUpdate = true;
    // geometry.computeBoundingSphere();
    // geometry.computeVertexNormals();
  }
}

/* Generic Object Helper functions */
export function Box2Points(p1, p2) {
  const geometry = new BoxGeometry(
    Math.abs(p1.x - p2.x),
    Math.abs(p1.y - p2.y),
    Math.abs(p1.z - p2.z)
  );
  geometry.translate(
    Math.min(p1.x, p2.x) + Math.abs(p1.x - p2.x) / 2,
    Math.min(p1.y, p2.y) + Math.abs(p1.y - p2.y) / 2,
    Math.min(p1.z, p2.z) + Math.abs(p1.z - p2.z) / 2
  );

  return geometry.toNonIndexed();
}

function AddCylinderY(x, z, y1, y2, radius) {
  const obj = new CylinderGeometry(radius, radius, Math.abs(y1 - y2), 32);
  obj.translate(x, (y1 + y2) / 2, z);
  return obj;
}

function AddCylinderZ(x, y, z1, z2, radius) {
  const obj = new CylinderGeometry(radius, radius, Math.abs(z1 - z2), 16);
  obj.translate(x, y, (z1 + z2) / 2);
  RotateObject(obj, null, 90, 'X');
  return obj;
}

function AddCylinderZ2(x, y, z1, z2, radius) {
  const obj = new CylinderGeometry(radius, radius, Math.abs(z1 - z2), 16);
  // obj.translate(x,y,(z1+z2)/2);
  RotateObject(obj, null, 90, 'X');
  obj.translate(x, y, (z1 + z2) / 2);
  return obj;
}

//TO REFACTOR
function CreateRoundedRectangleZ(width, height, depth, r) {
  const box1 = Box2Points(
    new Vector3(0, 0, r),
    new Vector3(width, depth, height - r)
  );
  const box2 = Box2Points(
    new Vector3(r, 0, 0),
    new Vector3(width - r, depth, height)
  );
  const cyl1 = AddCylinderY(r, r, 0, depth, r);
  const cyl2 = AddCylinderY(width - r, r, 0, depth, r);
  const cyl3 = AddCylinderY(width - r, height - r, 0, depth, r);
  const cyl4 = AddCylinderY(r, height - r, 0, depth, r);
  return BooleanUnion(box1, box2, cyl1, cyl2, cyl3, cyl4);
}

//function CreateRoundedRectangle(x: number, y: number, width: number, height: number, radius: number, thickness: number, quadraticCorners = false) {
export function CreateRoundedRectangle(
  x,
  y,
  width,
  height,
  radius,
  thickness,
  quadraticCorners = false
) {
  const roundedRectShape = new Shape();
  let geom;

  if (quadraticCorners) {
    // Quadratic corners (can look better, more bubbly)
    roundedRectShape.moveTo(x, y + radius);
    roundedRectShape.lineTo(x, y + height - radius);
    roundedRectShape.quadraticCurveTo(x, y + height, x + radius, y + height);
    roundedRectShape.lineTo(x + width - radius, y + height);
    roundedRectShape.quadraticCurveTo(
      x + width,
      y + height,
      x + width,
      y + height - radius
    );
    roundedRectShape.lineTo(x + width, y + radius);
    roundedRectShape.quadraticCurveTo(x + width, y, x + width - radius, y);
    roundedRectShape.lineTo(x + radius, y);
    roundedRectShape.quadraticCurveTo(x, y, x, y + radius);
  } else {
    // Circular corners (matches DOM's rounded borders)
    roundedRectShape.absarc(
      x + width - radius,
      y + radius,
      radius,
      -Math.PI / 2,
      0,
      false
    );
    roundedRectShape.absarc(
      x + width - radius,
      y + height - radius,
      radius,
      0,
      Math.PI / 2,
      false
    );
    roundedRectShape.absarc(
      x + radius,
      y + height - radius,
      radius,
      Math.PI / 2,
      Math.PI,
      false
    );
    roundedRectShape.absarc(
      x + radius,
      y + radius,
      radius,
      Math.PI,
      Math.PI + Math.PI / 2,
      false
    );
    roundedRectShape.lineTo(x + width - radius, y); // complete the loop
  }

  if (thickness > 0) {
    geom = new ExtrudeGeometry(roundedRectShape, {
      bevelEnabled: true,
      steps: 1,
      bevelSegments: 1,
      bevelSize: 0,
      bevelThickness: 0,
      depth: thickness,
    });
  } else {
    geom = new ShapeGeometry(roundedRectShape);
  }

  return geom.translate(-width / 2, -height / 2, -thickness / 2);
}

export function CreateHalfRoundedRectangle(
  x,
  y,
  width,
  height,
  radius,
  thickness
) {
  const roundedRectShape = new Shape();
  let geom;

  // Quadratic corners (can look better, more bubbly)
  roundedRectShape.moveTo(x, y + radius);
  roundedRectShape.lineTo(x, y + height - radius);
  roundedRectShape.quadraticCurveTo(x, y + height, x + radius, y + height);
  roundedRectShape.lineTo(x + width, y + height);
  roundedRectShape.lineTo(x + width, y);
  roundedRectShape.lineTo(x + radius, y);
  roundedRectShape.quadraticCurveTo(x, y, x, y + radius);

  if (thickness > 0) {
    geom = new ExtrudeGeometry(roundedRectShape, {
      bevelEnabled: true,
      steps: 1,
      bevelSegments: 1,
      bevelSize: 0,
      bevelThickness: 0,
      depth: thickness,
    }).toNonIndexed();
  } else {
    geom = new ShapeGeometry(roundedRectShape).toNonIndexed();
  }

  return geom.translate(-width / 2, -height / 2, -thickness / 2);
}

export function CreateHalfMoon(x, y, width, height, thickness) {
  const shape = new Shape();
  let geom;

  const radius = (width * width + (height * height) / 4) / (2 * width);
  const startAngle = Math.asin(height / (2 * radius));
  // Quadratic corners
  shape.moveTo(x, y);
  shape.arc(width - radius, 0, radius, startAngle, -startAngle, true);
  shape.lineTo(x, y);

  if (thickness > 0) {
    geom = new ExtrudeGeometry(shape, {
      bevelEnabled: true,
      steps: 1,
      bevelSegments: 1,
      bevelSize: 0,
      bevelThickness: 0,
      depth: thickness,
    }).toNonIndexed();
  } else {
    geom = new ShapeGeometry(shape).toNonIndexed();
  }

  return geom.translate(-width / 2, 0, -thickness / 2);
}

/* Track Helper functions */

export function CreateTrack(length = 800, width = 40, thickness = 6) {
  const object = new BoxGeometry(length, thickness, width).toNonIndexed();
  object.translate(length / 2, thickness / 2, 0);

  return object;
}

/* Hanger Helper functions */

function CreateLoftHanger(
  width = 40,
  heigth = 80,
  thickness = 6,
  radius = 5.05
) {
  const con1 = Box2Points(
    new Vector3(-width / 2, 0, 0),
    new Vector3(width / 2, heigth, thickness)
  );

  const con2 = AddCylinderZ(0, thickness / 2, 0, thickness, width / 2);
  con2.translate(0, heigth, 0);
  let object = BooleanUnion(con1, con2);

  const con3 = AddCylinderZ(
    0,
    thickness / 2,
    -thickness,
    2 * thickness,
    radius
  );
  con3.translate(0, heigth, 0);
  object = BooleanDifference(object, con3);

  RotateObject(object, (0, 0, 0), 90, 'Y');
  RotateObject(object, (0, 0, 0), 90, 'Z');

  return object;
}

/* Lara Helper functions */
export function CreateUFrame(
  length = 1000,
  width = 28,
  hanger = false,
  hanger_margin = 90
) {
  let object = Box2Points(
    new Vector3(0, 0, 0),
    new Vector3(width, width, length)
  );

  const pt0 = new Vector3(-1, 0, 0);
  const pt1 = new Vector3(width + 1, width + 1, 2 * width);
  const box1 = Box2Points(pt0, pt1);
  const box2 = box1.clone();

  RotateObject(box1, (0, 0, 0), -45, 'X');
  RotateObject(box2, (0, 0, length - width), 45, 'X');
  box2.translate(0, 0, length - width);
  box2.translate(0, width, 0);
  object = BooleanDifference(object, box1);
  object = BooleanDifference(object, box2);

  RotateObject(object, null, -90, 'Z');

  if (hanger) {
    const h1 = CreateLoftHanger();
    h1.translate(0, -40 + 6 * 2, 0);
    const h2 = h1.clone();
    h1.translate(0, 0.01, length - hanger_margin);
    h2.translate(0, 0.01, hanger_margin);
    object = BooleanUnion(object, h1, h2);
  }

  return object;
}

/* Industrial Helper functions */
export function CreateOFrame(
  length = 900,
  width = 20,
  depth = 40,
  thickness = 2,
  mitter = true,
  hanger = false,
  hanger_margin = 90
) {
  let object = Box2Points(
    new Vector3(0, 0, 0),
    new Vector3(width, depth, length)
  );
  //const obj2 = Box2Points(
  //  new Vector3(thickness, thickness, 0),
  //  new Vector3(width - thickness, depth - thickness, length)
  //);
  //let object = BooleanDifference(obj1, obj2);
  if (mitter) {
    const pt0 = new Vector3(0, 0, 0);
    const pt1 = new Vector3(
      Math.max(width, depth),
      Math.max(width, depth),
      2 * Math.max(width, depth)
    );
    const box1 = Box2Points(pt0, pt1);
    const box2 = box1.clone();

    RotateObject(box1, (0, 0, 0), 45, 'Y');
    RotateObject(box2, (0, 0, 0), -45, 'Y');
    box2.translate(Math.max(width, depth), 0, length - Math.max(width, depth));
    object = BooleanDifference(object, box1);
    object = BooleanDifference(object, box2);
  }
  if (hanger) {
    const h1 = CreateLoftHanger();
    const h2 = CreateLoftHanger();
    h1.translate(0, 0.01, length - hanger_margin);
    h2.translate(0, 0.01, hanger_margin);
    object = BooleanUnion(object, h1, h2);
  }
  return object;
}

/* Elegance Helper functions */
export function CreateLeftStyle(
  width = 120,
  length = 2100,
  thickness = 40,
  gw = 18,
  gd = 20,
  bg = 6
) {
  const pt0 = new Vector3(0, (thickness - gw) / 2, 0);
  const pt1 = new Vector3(width - gd, (thickness - gw) / 2 + gw, length);
  const box1 = Box2Points(pt0, pt1);
  const pt2 = new Vector3(0, 0, 0);
  const pt3 = new Vector3(width, (thickness - gw) / 2, length);
  const box2 = Box2Points(pt2, pt3);
  const box3 = box2.clone();
  box3.translate(0, (thickness - gw) / 2 + gw, 0);

  const pt4 = new Vector3(0, (thickness - bg) / 2, 0);
  const pt5 = new Vector3(width, (thickness - bg) / 2 + bg, bg);
  const box4 = Box2Points(pt4, pt5);

  let object = BooleanUnion(box1, box2, box3);
  object = BooleanDifference(object, box4);
  object.translate(-width / 2, -thickness / 2, 0);
  return object;
}

export function CreateRightStyle(
  width = 120,
  length = 2100,
  thickness = 40,
  gw = 18,
  gd = 20,
  bg = 6
) {
  const pt0 = new Vector3(gd, (thickness - gw) / 2, 0);
  const pt1 = new Vector3(width, (thickness - gw) / 2 + gw, length);
  const box1 = Box2Points(pt0, pt1);
  const pt2 = new Vector3(0, 0, 0);
  const pt3 = new Vector3(width, (thickness - gw) / 2, length);
  const box2 = Box2Points(pt2, pt3);
  const box3 = box2.clone();
  box3.translate(0, (thickness - gw) / 2 + gw, 0);

  const pt4 = new Vector3(0, (thickness - bg) / 2, 0);
  const pt5 = new Vector3(width, (thickness - bg) / 2 + bg, bg);
  const box4 = Box2Points(pt4, pt5);

  let object = BooleanUnion(box1, box2, box3);
  object = BooleanDifference(object, box4);
  object.translate(-width / 2, -thickness / 2, 0);
  return object;
}

export function CreateTopRail(
  width = 120,
  length = 560,
  thickness = 40,
  gw = 18,
  gd = 20
) {
  const pt0 = new Vector3(0, (thickness - gw) / 2, gd);
  const pt1 = new Vector3(2 * gd + length, (thickness - gw) / 2 + gw, width);
  const box1 = Box2Points(pt0, pt1);

  const pt2 = new Vector3(gd, 0, 0);
  const pt3 = new Vector3(gd + length, (thickness - gw) / 2, width);
  const box2 = Box2Points(pt2, pt3);
  const box3 = box2.clone();
  box3.translate(0, (thickness - gw) / 2 + gw, 0);

  const object = BooleanUnion(box1, box2, box3);

  object.translate(-length / 2, -thickness / 2, 0);
  return object;
}

export function CreateBottomRail(
  width = 120,
  length = 560,
  thickness = 40,
  gw = 18,
  gd = 20,
  bg = 6
) {
  const pt0 = new Vector3(0, (thickness - gw) / 2, 0);
  const pt1 = new Vector3(
    2 * gd + length,
    (thickness - gw) / 2 + gw,
    width - gd
  );
  const box1 = Box2Points(pt0, pt1);

  const pt2 = new Vector3(gd, 0, 0);
  const pt3 = new Vector3(gd + length, (thickness - gw) / 2, width);
  const box2 = Box2Points(pt2, pt3);
  const box3 = box2.clone();
  box3.translate(0, (thickness - gw) / 2 + gw, 0);

  let object = BooleanUnion(box1, box2, box3);

  object.translate(-length / 2, -thickness / 2, 0);

  return object;
}

export function CreateMiddleRail(
  width = 120,
  length = 560,
  thickness = 36,
  gw = 18,
  gd = 20
) {
  const pt0 = new Vector3(0, (thickness - gw) / 2, gd);
  const pt1 = new Vector3(
    2 * gd + length,
    (thickness - gw) / 2 + gw,
    width - gd
  );
  const box1 = Box2Points(pt0, pt1);

  const pt2 = new Vector3(gd, 0, 0);
  const pt3 = new Vector3(gd + length, (thickness - gw) / 2, width);
  const box2 = Box2Points(pt2, pt3);
  const box3 = box2.clone();
  box3.translate(0, (thickness - gw) / 2 + gw, 0);

  let object = BooleanUnion(box2, box3);

  object.translate(-length / 2, -thickness / 2, 0);
  return object;
}

export function CreateBrace(
  width = 700,
  height = 2100,
  brace_width = 120,
  thickness = 10,
  style = '/',
  th = 0
) {
  const list = [];
  const b = width / (height - brace_width);
  const alpha1 =
    -b + Math.sqrt(b * b + (height + brace_width) / (height - brace_width));
  const alpha2 =
    -b - Math.sqrt(b * b + (height + brace_width) / (height - brace_width));
  const theta = 90 - (2 * Math.atan(alpha1) * 180) / Math.PI;
  const box = Box2Points(
    new Vector3(0, 0, 0),
    new Vector3(brace_width, thickness, height * 2)
  );

  RotateObject(box, new Vector3(0, 0, 0), theta, 'Y');

  const cut1 = Box2Points(
    new Vector3(0, 0, height - 1),
    new Vector3(2 * width, thickness, 2 * height - 1)
  );
  const cut2 = Box2Points(
    new Vector3(0, 0, 1),
    new Vector3(2 * width, thickness, -height + 1)
  );
  let object1 = BooleanDifference(box, cut1);
  object1 = BooleanDifference(object1, cut2);

  if (style == '/') {
    list.push(object1);
  }
  if (style == 'L') {
    object1 = MirrorObjectZ(object1, false);
    object1.translate(0, 0, height);
    list.push(object1);
  }
  if (style != '/' && style != 'L') {
    // style x
    object1 = MirrorObjectZ(object1, false);
    const object2 = MirrorObjectZ(object1, true);
    object1.translate(0, 0, height);

    const object3 = BooleanIntersection(object1, object2);
    object3.center();
    object3.scale(1.1, 1, 1.1);
    object3.translate(width / 2, 0, height / 2);
    list.push(object1);
    list.push(BooleanDifference(object2, object3));
  }

  return { list, theta };
}

function CreateCurveByPoints(points, depth) {
  const shape = new Shape();
  shape.moveTo(points[0][0], points[0][1]);
  points.forEach((z, index) => {
    if (index == 0) return;
    shape.lineTo(z[0], z[1]);
  });

  const extrudeSettings = {
    bevelEnabled: false,
    depth: depth,
  };
  const geometry = new ExtrudeGeometry(shape, extrudeSettings);
  return geometry;
}

export function CreateSlat(
  width = 100,
  length = 2100,
  thickness = 18,
  chamfer = 5
) {
  const points = [
    [chamfer, 0],
    [width - chamfer, 0],
    [width, chamfer],
    [width, thickness - chamfer],
    [width - chamfer, thickness],
    [chamfer, thickness],
    [0, thickness - chamfer],
    [0, chamfer],
  ];

  const geometry = CreateCurveByPoints(points, length);
  geometry.translate(0, -thickness / 2, 0);

  return geometry;
}

export function CreateSlats(
  width = 700,
  length = 2100,
  slat_size = 100,
  thickness = 18,
  style = 'vertical'
) {
  let internal_width;
  let internal_length;

  if (style == 'horizontal') {
    internal_width = length;
    length = width;
    width = internal_width;
  }

  if (style == 'oblic') {
    internal_width = width;
    internal_length = length;
    length = width = length + width;
  }

  let full_slats_count = Math.trunc(width / slat_size);
  let slat_ends_width = (width - full_slats_count * slat_size) / 2;
  if (slat_ends_width < thickness / 3) {
    full_slats_count -= 2;
    slat_ends_width = slat_size;
  }
  const slat_length = length;

  const slats = [];

  slats.push(CreateSlat(slat_ends_width, slat_length, thickness));
  for (let i = 0; i < full_slats_count; i++) {
    slats.push(CreateSlat(slat_size, slat_length, thickness));
  }
  slats.push(CreateSlat(slat_ends_width, slat_length, thickness));

  for (let i = 0; i < full_slats_count + 1; i++) {
    slats[i + 1].translate(slat_ends_width + i * slat_size, 0, 0);
  }

  const bufferSlats = BufferGeometryUtils.mergeGeometries(slats);

  if (style == 'horizontal') {
    RotateObject(bufferSlats, new Vector3(0, 0, 0), 90, 'Y');
    bufferSlats.translate(0, 0, internal_width);

    return [bufferSlats];
  }
  if (style == 'oblic') {
    const oblic_cube = Box2Points(
      new Vector3(0, -10, 0),
      new Vector3(internal_width, 10, internal_length)
    );

    RotateObject(bufferSlats, new Vector3(0, 0, 0), -45, 'Y');
    bufferSlats.translate(
      internal_width / Math.sqrt(2),
      0,
      -internal_width / Math.sqrt(2)
    );

    return [BooleanIntersection(bufferSlats, oblic_cube)];
    // return [BooleanIntersectionBHV(bufferSlats, oblic_cube)];
  }

  return [bufferSlats];
}

export function CreateHandleInnerHole(
  width = 40,
  height = 160,
  radius = 10,
  depth = 12
) {
  const object = CreateRoundedRectangleZ(width, height, radius, depth);

  object.translate(-width / 2, -depth / 2, -height / 2);

  return object;
}

/* Minimalist Helper functions */
export function DecomposeMinimalistHeight(height) {
  const switcher = {
    2000: [400, 400, 400, 400, 400],
    2100: [400, 400, 500, 400, 400],
    2200: [400, 450, 500, 450, 400],
    2300: [450, 450, 500, 450, 450],
    2400: [450, 500, 500, 500, 450],
    2500: [500, 500, 500, 500, 500],
  };

  return switcher[height] ? switcher[height] : [450, 450, 500, 450, 450];
}

/* Function to create a CSS text label */
export function createCSSLabel(text, position) {
  const div = document.createElement('div');
  // div.style.width = '100px';
  // div.style.height = '30px';
  div.style.opacity = 0.6;
  div.style.background = 'white';
  div.style.border = '1px solid grey';
  div.style.color = 'grey';
  // div.style.boxShadow = '0 0 10px rgba(0,0,0,0.5)';
  div.innerHTML = text;
  div.style.textAlign = 'center';
  div.style.fontSize = '0.8em';
  // div.style.lineHeight = '30px';
  div.style.padding = '5px';
  div.style.borderRadius = '5px';

  const label = new CSS2DObject(div);
  label.position.copy(position);
  return label;
}

/* Function to create arrows */
export function createArrow(from, to, color) {
  const arrowGroup = new Group();
  const direction = from.clone().sub(to);
  const length = direction.length();

  arrowGroup.add(
    new ArrowHelper(direction.normalize(), from, length, 'grey', 50, 20)
  );
  direction.negate();
  arrowGroup.add(
    new ArrowHelper(direction.normalize(), from, length, 'grey', 50, 20)
  );
  return arrowGroup;
}
